import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: `${rem(16)} ${rem(8)}`,
      gap: rem(16),
      boxShadow:
        '0px 0px 1px 0px rgba(0, 0, 0, 0.04), 0px 2px 8px 0px rgba(0, 0, 0, 0.04), 0px 16px 24px 0px rgba(0, 0, 0, 0.06)',
      alignItems: 'center',
      cursor: 'pointer',
      borderRadius: rem(16),
      background: '#fff',
      [theme.fn.smallerThan('sm')]: {
        width: '100%',
        flexDirection: 'row',
        padding: rem(12),
      },
      [theme.fn.largerThan('sm')]: {
        gap: rem(24),
      },
    },
    imgWrapper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: rem(12),
      flexShrink: 0,
      width: rem(48),
      height: rem(48),
      [theme.fn.largerThan('sm')]: {
        borderRadius: rem(16),
        width: rem(64),
        height: rem(64),
      },
      svg: {
        width: rem(48),
        height: rem(48),
        [theme.fn.largerThan('sm')]: {
          width: rem(64),
          height: rem(64),
        },
      },
    },
    title: {
      textAlign: 'center',
      [theme.fn.smallerThan('sm')]: {
        textAlign: 'left',
        fontSize: rem(16),
      },
      [theme.fn.largerThan('sm')]: {
        fontSize: rem(18),
        maxWidth: rem(220),
      },
    },
  }
})
